import { ApiService } from 'src/app/api.service';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss']
})
export class MenuMobileComponent {
  categories: any;
  subCategories: any;
  subSubCategories: any;
  categorySelected: any;
  subCategorieSelected: any;
  isMenuVisible: boolean = false;
  isRepresentanteVisible: boolean = false;
  activeDropdowns: string[] = [];
  subcategorieReports: any[]= []


  private destroy$ = new Subject();

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<MenuMobileComponent>,
    private router: Router
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.closeMenu();
    });
  }

  ngOnDestroy() {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }

  async checkHasProducts(subcategorias: any){
    if(!subcategorias) return;
    subcategorias.forEach(async (categoria: any) =>{
      let products = await this.apiService.getCategoriesWithProductsFiltered(categoria.id)
      if(products.length > 0){
        categoria.hasProducts = true;

      } else{
        categoria.hasProducts = false;
      }
    })
    return subcategorias
  }

  toggleDropdown(menu: string) {

    const index = this.activeDropdowns.indexOf(menu);
    if (index !== -1) {

      this.activeDropdowns.splice(index, 1);
    } else {

      this.activeDropdowns.push(menu);
    }
  }

  isDropdownActive(menu: string): boolean {
    return this.activeDropdowns.includes(menu) ;
  }

  isDropdownActiveClass(menu: string): string {
    return this.isDropdownActive(menu) ? 'open' : 'close';
  }

  showMenu() {
    this.isMenuVisible = true;
  }

  showRepresentante() {
    this.isRepresentanteVisible = true;
  }
  showReports() {
    if (this.subcategorieReports.length > 0) {
        this.subcategorieReports = [];
    } else {
      this.subcategorieReports = [
      {nome: 'Metalúrgica 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatorio+Transparencia+Metal.pdf'},
      {nome: 'Metalúrgica 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 03/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatório+Transparência+032026+-+Metalúrgica.pdf'},

      {nome: 'Plástico 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/relatorio+Transparecncia+Plasticos.pdf'},
      {nome: 'Plástico 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 03/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Plasticos.pdf'}
    ]
    }
  }
  hideReport(){
    this.subcategorieReports = [];
  }

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(){
    this.apiService.loadCategories().then((result => {
      this.categories = result
      this.categories.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
      return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
      });
    }))
  }

  closeMenu(){
  this.dialogRef.close();
  }

  showSubcategory(show: boolean, category: any){
    if(this.categorySelected === category.id){
      show = false
      this.categorySelected = null
    } else {
      this.categorySelected = category.id
    }

    if (show) {
      category.categorias.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
      this.subCategories = category.categorias;
      this.subSubCategories = [];
    } else {
      this.subSubCategories = [];
    }

  }

  async showSubSubcategory(show: boolean, subCategory: any){

    if(this.subCategorieSelected === subCategory.id){
      show = false
      this.subCategorieSelected = null
    } else {
      this.subCategorieSelected = subCategory.id
    }

    if(show){
      this.subSubCategories = await this.checkHasProducts(subCategory.subcategorias);

    } else{
      this.subSubCategories = [];
    }
  }

}
